export default __webpack_public_path__ + "static/media/19-100.7f24e87c.jpg";